import StripeCheckoutButton from './StripeCheckoutButton';

import classNames from 'classnames';
import { FREE_TIER_CTA } from '../Pricing.constants';
import * as styles from '../Pricing.css';

interface Props {
  isFreePlan: boolean;
  ctaText?: string;
  isCtaDisabled: boolean;
  borderRadius?: string;
}

const ExternalCheckout = ({ isFreePlan, isCtaDisabled, ctaText, borderRadius = '0px' }: Props) => {
  if (isFreePlan) {
    return (
      <input
        type="submit"
        value={ctaText || FREE_TIER_CTA}
        style={{ borderRadius: borderRadius }}
        className={classNames(styles.inputSubmit, 'rounded-md py-2 px-4')}
      />
    );
  }

  return <StripeCheckoutButton isDisabled={isCtaDisabled} ctaText={ctaText || 'Upgrade'} />;
};

export default ExternalCheckout;
